angular.module('ui-ng-calendar').factory('TimeActionsEnum', function (Enumeration) {
  return Enumeration('TimeActionsEnum', {
    LOAD: {
      name: 'load',
      command: 'loadUnavailableTimesCommand'
    },
    SAVE: {
      name: 'save',
      command: 'saveUnavailableTimeCommand'
    },
    DELETE: {
      name: 'delete',
      command: 'deleteUnavailableTimeCommand'
    }
  });
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/old/types/time_actions_enum.es.js